import { useMemo } from 'react';
import { Url } from '@rossum/api-client';
import { Autocomplete, TextField } from '@rossum/ui/material';
import { useGetCredentials } from '../core/hooks';

type CredentialsMultiSelectProps = {
  value: Url[];
  onChange: (values: Url[]) => void;
};

export const CredentialsMultiSelect = ({
  value,
  onChange,
}: CredentialsMultiSelectProps) => {
  const { data: credentials = [], isLoading } = useGetCredentials();

  const selectedCredentials = useMemo(
    () => credentials.filter(credential => value.includes(credential.url)),
    [credentials, value]
  );

  return (
    <Autocomplete
      data-cy="credentials-multi-select"
      multiple
      size="small"
      loading={isLoading}
      disabled={isLoading}
      options={credentials}
      getOptionLabel={credential => credential.name}
      isOptionEqualToValue={(option, selected) => option.url === selected.url}
      value={selectedCredentials}
      disableCloseOnSelect
      onChange={(_e, newValue) =>
        onChange(newValue.map(credential => credential.url))
      }
      renderInput={params => <TextField {...params} />}
    />
  );
};
